export default "__VITE_ASSET__CUDextsF__"